import { io } from 'socket.io-client';

const BASE_SOCKET_URL = process.env.REACT_APP_BASE_URL || 'ws://localhost:3000';

export const socket = io(BASE_SOCKET_URL);
